export default __webpack_public_path__ + "static/media/heart-color.08302e75.svg";